<script>
export default {
  props: ['project'],
};
</script>

<template>
  <router-link :to="'/projects/' + project.id" class="block card">
    <div>
      <div class="card-image"><img :src="project.img" :alt="project.title" class="" /></div>
      <p class="card-title">{{ project.title }}</p>
      <p class="footer">
        {{ project.category }}
      </p>
    </div>
  </router-link>
</template>

<style scoped>
/* From Uiverse.io by Sashank02 */
.card {
  padding: 20px;
  width: 100%;
  min-height: 370px;
  border-radius: 30px;
  background: transparent;
  transition: 0.4s;
  border: 1px solid var(--card-1);  
}

.card:hover {
  box-shadow: 0 0 10px 0 var(--card-1);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--ui-2);
  margin: 15px 0 0 10px;
  text-align: left;
}

.card-image {
  aspect-ratio: 12/9;
  background-color: #313131;
  border-radius: 15px;
  background: #313131;
  box-shadow: inset 5px 5px 3px #2f2f2f,
    inset -5px -5px 3px #333333;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.card-body {
  margin: 13px 0 0 10px;
  color: rgb(184, 184, 184);
  font-size: 15px;
}

.footer {
  float: right;
  margin: 28px 0 0 18px;
  font-size: 13px;
  color: var(--ui-3);
}

</style>
